import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Form, Search, Button, Icon, Label, List,
} from 'semantic-ui-react';
import SearchContext from '../../../contexts/SearchContext';
import useTermsAutocomplete from '../../../hooks/useTermsAutocomplete';

const SearchPhraseForm = () => {
  const history = useHistory();
  const { queries } = useContext(SearchContext);
  const [phrase, setPhrase] = useState('');
  const {
    results,
    isLoading,
    handleSearchChange,
    resultRenderer,
  } = useTermsAutocomplete();

  const params = new URLSearchParams(useLocation().search);

  const handleResultSelect = (e, { result }) => {
    const selectedTerm = result.title.replace(/<[^>]*>/g, '');
    setPhrase(selectedTerm);
    // Add the selected term
    params.append('queries', selectedTerm);
    params.set('page', 1);
    history.push({ pathname: '/search', search: `?${params.toString()}` });
  };

  const addPhrase = () => {
    const newTerm = phrase.trim();
    if (newTerm) {
      params.append('queries', newTerm);
      params.set('page', 1);
      history.push({ pathname: '/search', search: `?${params.toString()}` });
    }
  };

  const removePhrase = (str) => {
    params.delete('queries', str);
    params.set('page', 1);
    history.push({ pathname: '/search', search: `?${params.toString()}` });
  };

  return (
    <Form onSubmit={addPhrase}>
      <Search
        resultRenderer={resultRenderer}
        fluid
        input={{ fluid: true }}
        placeholder="Add search phrase"
        className="nav-item"
        value={phrase}
        onSearchChange={(e, data) => handleSearchChange(e, data, setPhrase)}
        onResultSelect={handleResultSelect}
        results={results}
        loading={isLoading}
        icon={<Button icon><Icon name="search" /></Button>}
      />
      <List>
        {queries.map((query) => (
          <List.Item key={query}>
            <Label>
              {queries.length > 1 && (
                <Icon
                  link
                  name="close"
                  onClick={() => removePhrase(query)}
                  style={{ marginRight: '0.5rem' }}
                />
              )}
              {query}
            </Label>
          </List.Item>
        ))}
      </List>

    </Form>
  );
};

export default SearchPhraseForm;
